import styled from 'styled-components';

export const ButtonContainer = styled.div`
  & > button {
    margin: 12px 12px 0 0;
  }
`;
